export default __webpack_public_path__ + "static/media/email.ac84813f.png";